export default {
    namespaced: true,
    state: {
        wishlist: []
    },
    mutations: {
        setWishlist(state, status) {
            state.wishlist = status;
        },
        removeProduct(state, { userId, productId }) {
            let updatedWishlist;

            if (userId === 'guest') {
                // Для гостя, фильтруем вишлист в состоянии
                updatedWishlist = state.wishlist.filter(product => product.productId._id !== productId);
            } else {
                // Для авторизованного пользователя
                updatedWishlist = {
                    ...state.wishlist,
                    products: state.wishlist.products.filter(product => product.productId._id !== productId)
                };
            }

            // Обновляем состояние с новым вишлистом через setWishlist
            this.commit('wishlist/setWishlist', updatedWishlist)
        }
    },
    actions: {
        async addToWishlist(context, { userId, productId }) {
            console.log('Отправляемые данные в запросе:', { userId, productId });

            if (userId === 'guest') {
                // Получаем текущий список товаров из localStorage
                let existingCart = [];
                const guestWishlistString = localStorage.getItem('guestWishlist');
                if (guestWishlistString) {
                    try {
                        existingCart = JSON.parse(guestWishlistString);
                    } catch (error) {
                        console.error('Ошибка при парсинге данных из localStorage:', error);
                        existingCart = [];
                    }
                }

                // Создаем новый товар для добавления
                const newCart = [...existingCart, { productId }];

                // Сохраняем обновленный список в localStorage
                try {
                    localStorage.setItem('guestWishlist', JSON.stringify(newCart));
                } catch (error) {
                    console.error('Ошибка при сохранении данных в localStorage:', error);
                }

                // Обновляем состояние Vuex
                context.commit('setWishlist', newCart);
            } else {
                try {
                    const response = await fetch(`${process.env.VUE_APP_URL}/wishlist`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userId, productId }),
                    });

                    if (response.ok) {
                        const data = await response.json();
                        console.log('Товар успешно добавлен в вишлист:', data);
                    } else {
                        const errorData = await response.json();
                        console.error('Ошибка при добавлении в вишлист:', errorData);
                    }
                } catch (error) {
                    console.error('Ошибка при выполнении запроса:', error);
                }
            }
        },

        async fetchWishlist(context, userId) {
            if (userId === 'guest') {
                let guestCart = [];
                const guestWishlistString = localStorage.getItem('guestWishlist');
                console.log('Данные из localStorage для гостя:', guestWishlistString);

                if (guestWishlistString) {
                    try {
                        guestCart = JSON.parse(guestWishlistString);
                        console.log('parsed guestCart:', guestCart);
                    } catch (error) {
                        console.error('Ошибка при парсинге данных из localStorage:', error);
                    }
                }

                const ids = guestCart.map(item => item.productId);
                try {
                    const res = await fetch(`${process.env.VUE_APP_URL}/products`);
                    const text = await res.text();

                    if (!res.ok) {
                        throw new Error(`Ошибка при получении всех товаров: ${res.status}`);
                    }

                    let allProducts;
                    try {
                        allProducts = JSON.parse(text); // Пробуем распарсить вручную
                        console.log('Товары:', allProducts);
                    } catch (error) {
                        console.error("Ошибка при парсинге JSON:", error);
                        return;
                    }

                    const fullProductCart = ids.map(productId => {
                        const product = allProducts.find(p => p._id === productId);
                        if (product) {
                            return {
                                _id: productId,
                                productId: product,
                            };
                        }
                    }).filter(product => product !== undefined);

                    console.log('full', fullProductCart);

                    // Коммитим данные в Vuex
                    context.commit('setWishlist', fullProductCart);

                } catch (error) {
                    console.error('Ошибка при загрузке данных вишлиста:', error);
                }
            } else {
                try {
                    const response = await fetch(`${process.env.VUE_APP_URL}/wishlist/${userId}`);
                    if (!response.ok) {
                        throw new Error(`Error: ${response.status}`);
                    }

                    const data = await response.json();
                    console.log('дата авторизованого пользователя:', data);

                    // Коммит данных в Vuex
                    context.commit('setWishlist', data);

                } catch (error) {
                    console.error('Error fetching cart data:', error);
                }
            }
        },

        async removeFromWishlist(context, { userId, productId }) {

            if (userId === 'guest') {
                const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist')) || [];
                const updatedWishlist = guestWishlist.filter(item => item.productId !== productId);

                localStorage.setItem('guestWishlist', JSON.stringify(updatedWishlist));

                context.commit('removeProduct', {userId, productId})
            }
            else {
                try {
                    const response = await fetch(`${process.env.VUE_APP_URL}/wishlist`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userId, productId })
                    });

                    if (response.ok) {
                        const data = await response.json();
                        context.commit('removeProduct', { userId, productId })
                        console.log('Товар успешно удален из вишлиста:', data);

                    } else {
                        const errorData = await response.json();
                        console.error('Ошибка при удалении из вишлиста:', errorData);
                    }

                } catch (error) {
                    console.error(error)
                }
            }
        }
    },
    getters: {
        getWishlist(state) {
            return state.wishlist || [];
        }
    }
}
